import { render, staticRenderFns } from "./ListPreferredDeliveryAddress.vue?vue&type=template&id=5518c61e"
import script from "./ListPreferredDeliveryAddress.vue?vue&type=script&lang=js"
export * from "./ListPreferredDeliveryAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ListPreferredDeliveryAddress.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5518c61e')) {
      api.createRecord('5518c61e', component.options)
    } else {
      api.reload('5518c61e', component.options)
    }
    module.hot.accept("./ListPreferredDeliveryAddress.vue?vue&type=template&id=5518c61e", function () {
      api.rerender('5518c61e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/ListPreferredDeliveryAddress.vue"
export default component.exports